import React from 'react';
import withStore from "@/hocs/withStore";

const PriceComponent = (props) => {
    let {product = {}, productDataActive = {}} = props;

    const {sale = {}, marker_discount_color = '', marker_discount_bg_color = ''} = product;

    const {
        price = 0, // Цена
        card_price = 0, // Цена со скидкой
        kol = 0 // Количество
    } = productDataActive;

    return <div className={`priceContainer`}>
        {price !== card_price ?
            <>
                <div className={`priceContainer__priceCurrent`}>
                    {card_price.toLocaleString('ru')} ₽
                </div>
                <div className={`priceContainer__priceOld`}>
                    {price.toLocaleString('ru')} ₽
                </div>
            </>
            :
            <div className={`priceContainer__priceCurrent`}>
                {card_price.toLocaleString('ru')} ₽
            </div>
        }
        {sale.discount !== 0 && kol !== 0 && (
            <div className={`priceContainer__discount`}
                 style={{
                     color: `${marker_discount_color}`,
                     backgroundColor: `${marker_discount_bg_color}`
                 }}
            >
                {`-${sale.discount}%`}
            </div>
        )}
    </div>
}

export default withStore(PriceComponent);
